"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable no-empty */
var socket_io_client_1 = require("socket.io-client");
var EventEmitter = require("mitt/dist/mitt.umd");
var utils_1 = require("../utils");
var BaseSocketService = /** @class */ (function () {
    function BaseSocketService() {
        this.emitter = new EventEmitter();
        this.socket = null;
        this.requests = {};
    }
    BaseSocketService.prototype.on = function (type, handler) {
        this.emitter.on(type, handler);
    };
    BaseSocketService.prototype.off = function (type, handler) {
        this.emitter.off(type, handler);
    };
    BaseSocketService.prototype.emit = function (type, event) {
        this.emitter.emit(type, event);
    };
    Object.defineProperty(BaseSocketService.prototype, "transports", {
        get: function () {
            return ["websocket"];
        },
        enumerable: true,
        configurable: true
    });
    BaseSocketService.prototype.secured = function (url) {
        return !url.includes("local");
    };
    Object.defineProperty(BaseSocketService.prototype, "reconnectionAttempts", {
        get: function () {
            return 100;
        },
        enumerable: true,
        configurable: true
    });
    BaseSocketService.prototype.onSocketConnect = function () { };
    BaseSocketService.prototype.onSocketConnectError = function (err) { };
    BaseSocketService.prototype.onSocketConnectTimeout = function () { };
    BaseSocketService.prototype.onSocketError = function (err) { };
    BaseSocketService.prototype.onSocketDisconnect = function () { };
    BaseSocketService.prototype.initialize = function (url, token, includeTokenInQuery) {
        var _this = this;
        if (includeTokenInQuery === void 0) { includeTokenInQuery = true; }
        return new Promise(function (resolve, reject) {
            var options = {
                transports: _this.transports,
                secure: _this.secured(url),
                reconnectionAttempts: _this.reconnectionAttempts,
                auth: {
                    token: token
                }
            };
            if (includeTokenInQuery) {
                options.query = { token: token };
            }
            _this.socket = socket_io_client_1.default(url, options);
            _this.socket.on("connect", function () { return _this.onConnect(resolve); });
            _this.socket.on("connect_error", function (err) { return _this.onConnectError(reject, err); });
            _this.socket.on("connect_timeout", function (err) { return _this.onConnectTimeout(reject, err); });
            _this.socket.on("error", function (err) { return _this.onError(reject, err); });
            _this.socket.on("disconnect", function () { return _this.onDisconnect(); });
        });
    };
    BaseSocketService.prototype.onConnect = function (resolve) {
        console.log("connected to socket");
        this.isConnected = true;
        this.onSocketConnect();
        resolve();
    };
    BaseSocketService.prototype.onConnectError = function (reject, err) {
        console.error("failed to connect to socket");
        this.onSocketConnectError(err);
        reject(err);
    };
    BaseSocketService.prototype.onConnectTimeout = function (reject, err) {
        console.error("socket timeout");
        this.onSocketConnectTimeout();
    };
    BaseSocketService.prototype.onError = function (reject, err) {
        console.error("socket error");
        this.onSocketError(err);
        reject(err);
    };
    BaseSocketService.prototype.onDisconnect = function () {
        console.log("socket disconnected");
        this.isConnected = false;
        for (var key in this.requests) {
            if (this.requests.hasOwnProperty(key)) {
                var request = this.requests[key];
                clearTimeout(request.reject.timeoutInterval);
                request.reject({ message: "service_unavailable", code: 503 });
                delete this.requests[key];
            }
        }
        this.onSocketDisconnect();
    };
    BaseSocketService.prototype.request = function (eventName, data, expire) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this.isConnected) {
                return reject({ message: "service_unavailable", code: 503 });
            }
            var id = utils_1.guid();
            _this.requests[id] = {
                resolve: resolve,
                reject: reject
            };
            reject.timeoutInterval = setTimeout(function () {
                delete _this.requests[id];
                reject({ message: "request_timeout", code: 408 });
            }, expire || 5 * 60 * 1000);
            _this.socket.emit(eventName, data, function (reply) {
                delete _this.requests[id];
                clearTimeout(reject.timeoutInterval);
                reply.success ? resolve(reply.data) : reject(reply);
            });
        });
    };
    return BaseSocketService;
}());
exports.default = BaseSocketService;
